import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { GrCertificate } from "react-icons/gr";
import queryString from "query-string";
import Moment from "react-moment";
import nointerviewsimage from "../../assests/nointerviewshere.png";
import PdfViewer from "./pdfViewer";
import { apiGet, apiPostPut } from "../../api/api_methods";
import {
  FaUser,
  FaClock,
  FaUserTie,
  FaTags,
  FaHashtag,
  FaMicrophone,
  FaVideo,
  FaChartBar,
} from "react-icons/fa";
import {
  interviewsList,
  interviewsProList,
} from "../../helpers/constantVariables";

import { RiProfileLine } from "react-icons/ri";
import { Document, Page } from "react-pdf";
import { FiAlertTriangle } from "react-icons/fi";
import { apiLink, publicStorgeLink } from "../../helpers/constantVariables";
import Loader from "./loader";
import CountdownTimer from "../interview/timerComponent";
import {
  MdArrowCircleRight,
  MdDownload,
  MdInfoOutline,
  MdOutlineFileDownload,
} from "react-icons/md";
import { useStores } from "../../store/index";
import {
  AiFillCloseCircle,
  AiOutlineCopy,
  AiOutlineDownload,
  AiOutlineShareAlt,
} from "react-icons/ai";
import UserDetailsCard from "../recruiter/user_details_card";
import Dashboard, { PreviousInterview } from "../dashboard/dashboard";
import { TotalInterviews } from "../dashboard/dashboard";
import { IoIosDocument } from "react-icons/io";
import Behaviour from "../reusble_components/behavioural";

import { set, toJS } from "mobx";
import ReferAndEarn from "../dashboard/ReferAndEarn";
import {
  getUserDetailsFromLocalStorage,
  navigateToPageInNewTab,
} from "../../services/reusable";
import { Observer, useObserver } from "mobx-react";
import {
  Link,
  useLocation,
  useNavigate,
  useNavigation,
  useSearchParams,
} from "react-router-dom";
import { saveAs } from "file-saver";
import {
  getclusterbyDomain,
  getDomainForWhiteLabeling,
  getLogoBySubdomain,
} from "../../services/white_label";
import HelpCenter from "./helpCenter";
import JobShare from "../recruiter/Components/Job";
import ReportScreenShimmer from "./reportScreenShimmer";
import ApplicationProgress from "../dashboard/ApplicationProgress";
import HireDropDown from "./buttons/HireDropDown";

const ReportScreen = () => {
  const { InterviewStore, RecuiterStore, UserStore, CommonStore } = useStores();
  const [interviewId, setInterviewId] = useState(null);
  const [interviewData, setInterviewData] = useState(null);
  const [recordingId, setrecordingId] = useState(null);
  const [ans, setans] = useState(null);
  const [pdf, setPdf] = useState(false);
  const [questions, setquestions] = useState([]);
  const [view, setview] = useState(false);
  const [loader, setLoader] = useState(false);

  const [loading, setLoading] = useState(true);
  const [showTimer, setShowTimer] = useState(false);
  const [overallScore, setOverallScore] = useState(0);
  const [loadingVideo, setLoadingVideo] = useState(true);
  const [isRecordAvailable, setisRecordAvailable] = useState(null);
  const [resumeLink, setResumeLink] = useState(null);
  const [isResultGenerated, setIsResultGenerated] = useState(true);
  const [jobPostId, setJobPostId] = useState(null);
  const [interviewsData, setInterviewsData] = useState([]);
  const topref = useRef(null);
  // const defaultLayoutPluginInstance = defaultLayoutPlugin();
  // Sample data

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const fromInterview = JSON.parse(searchParams.get("fromInterview"));

  const interviewDetails = {
    intervieweeName: "John Doe",
    interviewDuration: "45 minutes",
    interviewerName: "Jane Smith",
    interviewTopic: "Software Engineering",
    interviewId: "12345",
    interviewPermissionMic: true,
    interviewPermissionVideo: true,
    interviewLevel: "Medium",
  };

  const checkUserLoggedInOrNot = () => {
    const user = getUserDetailsFromLocalStorage();
    console.log(interviewData);
    if (user) {
      if (user?.role?.role === "company") {
        return true;
      } else if (
        user?.role?.role === "student" &&
        user?._id == interviewData?.interviewee?._id
      ) {
        return true;
      }
    }
    return false;
  };

  const shallShowCandidateDetails = () => {
    const user = getUserDetailsFromLocalStorage();
    if (user && user?.role?.role === "student") {
      return false;
    }
    return true;
  };

  const getIdFromUrl = () => {
    try {
      const url = window.location.href;
      const id = url.split("/").pop();
      console.log(id);
      setInterviewId(id);
      return id;
    } catch (error) {
      return null;
    }
  };
  const sendReq = async () => {
    const firstQuestionLength = Object.keys(questions[0]).length;
    if (firstQuestionLength === 5) {
      setview(true);
      console.log("actual answers are available");
    } else {
      console.log("actual answers are not available api hit");
      const id = getIdFromUrl();

      if (id === null) {
        alert("Invalid interview id from url");
        return;
      }
      const body = {
        interviewId: id,
      };

      setLoading(true);
      const api = `/interview/correct-answer`;
      const response = await apiPostPut(body, api, "POST");

      if (response.status === 200) {
        setLoading(false);

        setquestions(response?.body?.data);
        setview(true);
        console.log("questions");

        console.log(questions);
      } else {
        setLoading(false);
        alert("Failed to send the Request");

        console.error("Error:", response); // Log the error for debugging
      }
    }
  };
  function downloadPDF(url) {
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.blob();
      })
      .then((blob) => {
        saveAs(blob, "document.pdf");
      })
      .catch((error) => {
        console.error("There was a problem with your fetch operation:", error);
      });
    console.log("download");
  }

  const getTheInterviewData = () => {
    const id = getIdFromUrl();

    if (id === null) return alert("Invalid interview id from url");
    setLoading(true);
    setisRecordAvailable(null);
    try {
      axios
        .get(`${apiLink}/interview/get-interview-by-id/${id}`)
        .then((res) => {
          setLoading(false);
          console.log(res.data);
          if (res?.data?.success) {
            setInterviewData(res?.data?.data);
            setrecordingId(res?.data?.data?.recording);
            setJobPostId(res?.data?.data?.jobPostId);

            // if (!res?.data?.data?.isResultPublished) {
            //   setIsResultGenerated(false);
            // }
            setIsResultGenerated(res?.data?.data?.isResultPublished);
            const recording = res?.data?.data?.recording;
            console.log(recording);
            if (recording) {
              setisRecordAvailable(true);
            } else {
              setisRecordAvailable(false);
              checkRecordedVideoAvailability(id);
            }
            return;
          }
          alert("Your report data not found");
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
          // alert("Error Occured");
          console.log("Error Occured");
        });
    } catch (error) {
      console.log(error);
      // alert("Error Occured");
      console.log("Error Occured");
      setLoading(false);
    }
  };

  const updateRecordingToServer = (id, storageLink) => {
    // this function will update the recording link to the server if the recording link is not available in the server
    if (
      interviewData?.recroding === undefined ||
      interviewData?.recroding === null
    ) {
      InterviewStore.updateInterviewById(id, { recording: storageLink });
    }
  };

  const checkRecordedVideoAvailability = async (id) => {
    if (isRecordAvailable !== null) return; // if already checked then return

    try {
      const storageLink = `${publicStorgeLink}/${id}.mp4`;

      // check if the video is available in the storage
      axios
        .get(storageLink)
        .then((res) => {
          console.log(res);
          if (res.status === 200) {
            setisRecordAvailable(true);
            updateRecordingToServer(id, storageLink);
          }
        })
        .catch((err) => {
          console.log(err);
          setisRecordAvailable(false);
        });
    } catch (error) {}
  };

  useEffect(() => {
    // getIdFromUrl();
    getTheInterviewData();
    try {
      if (topref.current) {
        topref.current.scrollIntoView({ behavior: "instant" });
      }
    } catch (error) {}
  }, [window.location.href]);

  useEffect(() => {
    if (interviewData === null) return;
    // isActualAnswersAvaialble();

    setquestions(interviewData?.questions);
    getTheAvarageScore(interviewData?.questions);
  }, [interviewData]);

  const getTheResultByTopic = (topic) => {
    if (interviewData === null) return "";
    const result = interviewData?.result?.filter((q) => q?.name === topic);

    return result[0]?.score ?? 0;
  };

  const hitResultAPI = (regenerate) => {
    setLoading(true);
    setShowTimer(true);
    console.log(regenerate);
    // isActualAnswersAvaialble();
    const body = {
      interviewId: interviewId,
      regenerate: regenerate ?? null,
    };
    try {
      let newBody = body;
      newBody = {
        ...newBody,
        cluster: getclusterbyDomain(),
      };

      axios
        .post(`${apiLink}/interview/result`, newBody)
        .then((res) => {
          if (res.status === 200) {
            alert("Your result generated successfully");
            setShowTimer(false);
            return getTheInterviewData();
          } else
            alert(
              "Something went wrong. Unable to generate result. error: 567",
            );
        })
        .catch((err) => {
          console.log(err);

          alert(`${err?.response?.data?.message}`);
        });
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const getTheAvarageScore = (questions) => {
    // retrieve the score from the questions array and calculate the average score skip if the score is 0
    let totalScore = 0;
    let totalQuestions = 0;
    questions.forEach((q) => {
      totalScore += parseInt(q?.score) || 0;
      totalQuestions++;
    });
    if (totalQuestions === 0) {
      setOverallScore(0);
      return 0;
    }

    setOverallScore(parseInt(totalScore / totalQuestions));
    return totalScore / totalQuestions;
  };

  const downloadReport = () => {
    window.print();
  };

  const downloadRecordedSession = (blob) => {
    try {
      const url = URL.createObjectURL(blob);
      console.log(url);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = "recording.webm";
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      alert("Unable to download");
    }
  };

  const getBlobFromMobx = ({ download = true }) => {
    const blobString = InterviewStore.screenRecorder;
    if (!blobString) return alert("NO recording found");
    if (blobString) {
      const byteCharacters = atob(blobString.split(",")[1]);
      const byteArrays = [];
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays.push(byteCharacters.charCodeAt(i));
      }
      const blob = new Blob([new Uint8Array(byteArrays)], {
        type: "video/webm",
      });
      console.log("Blob retrieved from Mobx:", blob);
      if (download) downloadRecordedSession(blob);
      return blob;
    } else {
      console.log("No Blob found in Mobx.");
      return null;
    }
  };

  const getVideoLinkFromStorage = () => {
    if (interviewData?.recording) {
      console.log(interviewData?.recording);

      return interviewData?.recording;
    }

    const storageLink = `${publicStorgeLink}/${interviewId}.mp4`;
    console.log(storageLink);

    return storageLink;
  };

  const downloadRecordedVideoFromStorage = () => {
    const link = getVideoLinkFromStorage();
    // alert(link)
    if (link) {
      window.open(link, "_blank");
    } else {
      alert("Video not found in the storage");
    }
  };

  const getScreenRecordVideo = () => {
    const localCheck = getBlobFromMobx({ download: false });
    if (localCheck != null) return localCheck;

    const interview_id = interviewId;

    const storageLink = `${publicStorgeLink}/${interview_id}.mp4`;

    // check if the video is available in the storage
    axios
      .get(storageLink)
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          // video found in the storage
          console.log("Video found in the storage");
          // const blob = res.data;
          // downloadRecordedSession(blob);
          // return blob;
          return storageLink;
        }
      })
      .catch((err) => {
        console.log(err);
        // video not found in the storage
        console.log("Video not found in the storage");
        // alert("Video not found in the storage");
        return null;
      });
  };
  const getInterviewTitle = (interviewId) => {
    const interview = interviewsList.find((item) => item.id === interviewId);
    return interview ? interview.title : "-";
  };

  const navigateToCertificate = () => {
    const data = {
      name: interviewData?.interviewee?.name,
      interviewTopic: interviewData?.technology,
      date: interviewData?.createdAt,
      technicalSkills: getTheResultByTopic("technical_score"),
      communicationSkills: getTheResultByTopic("communication_score"),
      overallRating: getOverallScore(),
    };
    const query = queryString.stringify(data);
    console.log("data:", data);
    window.open(`/Report?${query}`, "_blank");
  };

  const getOverallScore = () => {
    try {
      const technicalScore = getTheResultByTopic("technical_score");
      const communicationScore = getTheResultByTopic("communication_score");
      const overallScore =
        (Number(technicalScore) + Number(communicationScore)) / 2;
      return overallScore;
    } catch (error) {
      return 0;
    }
  };
  const [showPopup, setShowPopup] = useState(false);

  // ... other code ...

  const openPopup = () => {
    setShowPopup(true);
  };

  const handleCopyClick = () => {
    // Create a textarea element to temporarily hold the text
    const textarea = document.createElement("textarea");
    textarea.value = textToCopy;

    // Append the textarea to the document
    document.body.appendChild(textarea);

    // Select the text in the textarea and copy it to the clipboard
    textarea.select();
    document.execCommand("copy");

    // Remove the textarea from the document
    document.body.removeChild(textarea);
    window.alert("link copied");
  };
  const url = window.location.href;
  const id = url.split("/").pop();
  const handleButtonClick = () => {
    // Replace 'https://example.com' with your desired link

    window.location.href = `https://app.reaidy.io/share?page=report&id=${id}`;
  };
  const [textToCopy, setTextToCopy] = useState(
    `https://app.reaidy.io/report/${id}`,
  );

  const openResumeByLink = (link) => {
    if (checkUserLoggedInOrNot()) {
      if (!link) {
        return alert("Resume not found");
      }
      console.log(link);
      setResumeLink(link);
      // window.open(link, "_blank");
      // this is not working
      // const a = document.createElement("a");
      // a.style.display = "none";
      setPdf(true);
    } else {
      alert("Please login as a company to view the candidate resume");
      if (window.confirm("Would you like to login")) {
        navigateToPageInNewTab("");
      }
    }
  };

  const handlePopUp = (value) => {
    setShowPopup(value);
  };

  const closePopup = () => {
    // Update the state to hide the pop-up
    setShowPopup(false);
    setPdf(false);
  };

  const isActualAnswersAvaialble = () => {
    try {
      const firstQuestionLength = Object.keys(questions[0]).length;

      console.log("Length of the first question:", firstQuestionLength);
      if (firstQuestionLength === 5) {
        setview(true);
      } else {
        setview(false);
      }
    } catch (error) {
      setview(false);
      return;
    }
  };

  const downloadResumeByLink = (link, candidateName) => {
    if (!link) return alert("Resume not found");
    // download the resume by link
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = link;
    a.download = candidateName + ".pdf";
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(link);
    document.body.removeChild(a);
  };
  const navigate = useNavigate();

  const [lastInterview, setLastInterview] = useState(null);
  const [applicationId, setApplicationId] = useState(null);

  const fetchData = async (id) => {
    const response = await apiGet(
      `/application/application-assessments-status/${id}`,
    );
    if (response.success) {
      const data = response.body.data;
      console.log(data, "data");
      setInterviewData(data);
    }
  };
  useEffect(() => {
    const urlObj = new URL(url);
    const pathSegments = urlObj.pathname.split("/"); // Split the path by "/"
    const applicationId = pathSegments[pathSegments.length - 1]; // Get the last segment
    console.log("hello this is mocktestId", applicationId);
    UserStore.GetApplicationProgress(applicationId, "", "").then(() => {
      if (UserStore.ApplicationDetails) {
        fetchData(UserStore?.ApplicationDetails?.applicationId);
        console.log(
          "this is Application  Details",
          toJS(UserStore.ApplicationDetails),
        );
        if (
          UserStore.ApplicationDetails?.mockTestStatus === "pending" ||
          UserStore.ApplicationDetails?.mockTestStatus === "completed"
        ) {
          CommonStore.ApplicationProgress[1].hidden = false;
          if (UserStore.ApplicationDetails?.mockTestStatus === "pending") {
            CommonStore.ApplicationProgress[1].completed = false;
          } else {
            CommonStore.ApplicationProgress[1].completed = true;
          }
        } else {
          CommonStore.ApplicationProgress[1].hidden = true;
        }
        if (
          UserStore.ApplicationDetails?.technicalInterviewStatus ===
            "pending" ||
          UserStore.ApplicationDetails?.technicalInterviewStatus === "completed"
        ) {
          CommonStore.ApplicationProgress[2].hidden = false;
          if (
            UserStore.ApplicationDetails?.technicalInterviewStatus === "pending"
          ) {
            CommonStore.ApplicationProgress[2].completed = false;
          } else {
            CommonStore.ApplicationProgress[2].completed = true;
          }
        } else {
          CommonStore.ApplicationProgress[2].hidden = true;
        }
        if (
          UserStore.ApplicationDetails?.hrInterviewStatus === "pending" ||
          UserStore.ApplicationDetails?.hrInterviewStatus === "completed"
        ) {
          CommonStore.ApplicationProgress[3].hidden = false;
          if (UserStore.ApplicationDetails?.hrInterviewStatus === "pending") {
            CommonStore.ApplicationProgress[3].completed = false;
          } else {
            CommonStore.ApplicationProgress[3].completed = true;
          }
        } else {
          console.log(
            "UserStore.ApplicationDetails?.hrInterviewStatus",
            UserStore.ApplicationDetails?.hrInterviewStatus,
          );
          CommonStore.ApplicationProgress[3].hidden = true;
        }
        if (UserStore.ApplicationDetails?.shortlisted === true) {
          CommonStore.ApplicationProgress[4].completed = true;
        } else {
          CommonStore.ApplicationProgress[4].completed = false;
        }
        if (UserStore.ApplicationDetails?.hired === true) {
          CommonStore.ApplicationProgress[5].hired = true;
        } else {
          CommonStore.ApplicationProgress[5].hired = false;
        }
        if (UserStore.ApplicationDetails?.rejected === true) {
          CommonStore.ApplicationProgress[4].rejected = true;
        } else {
          CommonStore.ApplicationProgress[4].rejected = false;
        }
        setApplicationId(UserStore.ApplicationDetails?.applicationId);
        const getNextStepId = (details) => {
          if (
            details.mockTestStatus !== "completed" &&
            details.mockTestStatus !== null
          )
            return details.mockTestId;
          if (
            (details.mockTestStatus === "completed" ||
              details.mockTestStatus === null) &&
            details.technicalInterviewStatus !== "completed" &&
            details.technicalInterviewStatus !== null
          )
            return details.technicalId;
          if (
            (details.technicalInterviewStatus === "completed" ||
              details.technicalInterviewStatus === null) &&
            details.hrInterviewStatus !== "completed" &&
            details.hrInterviewStatus !== null
          )
            return details.hrId;
          return null; // All interviews completed, or null treated as completed
        };
        const nextStepId = getNextStepId(UserStore.ApplicationDetails);
        setLastInterview(nextStepId);
      }
    });
  }, []);

  return useObserver(() => (
    <div ref={topref} className="w-full  gil-reg bg-white relative">
      <HelpCenter />
      <Loader loader={loader} text={"updating the status..."} />
      <>
        {UserStore.ApplicationDetails && (
          <div className=" fixed bg-white md:left-20 md:top-0 lg:top-0 py-2 top-20 shadow-lg z-50 justify-between items-center rounded-lg md:w-[95vw] lg:w-[95vw] w-full md:px-[2%] lg:px-[2%] px-10 flex p-0">
            <div className="w-fit -ml-6 md:overflow-x-hidden lg:overflow-x-hidden md:overflow-x-hidden lg:overflow-x-hidden w-[60vw] md:-mb-0 lg:-mb-0 -mb-5 overflow-x-scroll no-scrollbar ">
              <ApplicationProgress className="w-fit" />
            </div>
            {
              //   {
              //     "success": true,
              //     "data": {
              //         "resumeCutOffCrossed": true,
              //         "technicalInterview": {
              //             "_id": "67990ebe751774d8c1a09a87",
              //             "isInterviewCompleted": true,
              //             "isResultPublished": true,
              //             "eligibleForNextRound": false
              //         },
              //         "hrInterview": {
              //             "_id": "67991182751774d8c1a0a243",
              //             "isInterviewCompleted": true,
              //             "isResultPublished": true,
              //             "eligibleForNextRound": false
              //         }
              //     }
              // }
              interviewData?.technicalInterview?.isInterviewCompleted &&
              interviewData?.technicalInterview?.isResultPublished &&
              interviewData?.technicalInterview?.eligibleForNextRound &&
              interviewData?.hrInterview?.isInterviewCompleted &&
              interviewData?.hrInterview?.isResultPublished &&
              interviewData?.hrInterview?.eligibleForNextRound ? (
                <>
                  {" "}
                  {lastInterview ? (
                    <>
                      <button
                        onClick={() => {
                          console.log(
                            "this is lastInterview and applicationid",
                            lastInterview,
                            applicationId,
                          );
                          if (lastInterview) {
                            navigate(
                              `/interview-invitation?meetingid=${lastInterview}&applicationId=${applicationId}`,
                            );
                          }
                        }}
                        className="bg-primary text-white h-fit md:text-base lg:text-base text-lg font-semibold w-fit px-5 py-1 md:hidden lg:hidden rounded-lg"
                      >
                        Continue
                      </button>
                      <button
                        onClick={() => {
                          console.log(
                            "this is lastInterview and applicationid",
                            lastInterview,
                            applicationId,
                          );
                          if (lastInterview) {
                            navigate(
                              `/interview-invitation?meetingid=${lastInterview}&applicationId=${applicationId}`,
                            );
                          }
                        }}
                        className="bg-primary text-white h-fit md:text-base lg:text-base text-xs font-semibold w-fit md:px-7 lg:px-7 py-3 md:flex lg:flex hidden rounded-xl"
                      >
                        Continue with Next step
                      </button>
                    </>
                  ) : (
                    <>
                      <p
                        onClick={() => console.log(lastInterview)}
                        className="bg-green-500 text-white h-fit md:text-base lg:text-base text-xs my-auto font-semibold w-fit md:px-7 lg:px-7 py-3 md:flex lg:flex hidden rounded-xl"
                      >
                        {" "}
                        Application Submitted Succesfully
                      </p>
                      <p className="bg-green-500 text-white h-fit md:text-base lg:text-base text-xs my-auto truncate font-semibold w-fit px-5 py-2 md:hidden lg:hidden rounded-lg">
                        {" "}
                        Submitted Succesfully
                      </p>
                    </>
                  )}{" "}
                </>
              ) : (
                <></>
                // <p className="text-red-500 flex gap-2">
                //   You are Rejected
                //   <div className="group relative flex items-center gap-2">
                //     <MdInfoOutline className="text-red-500 cursor-pointer" />

                //     {
                //       <div className="absolute hidden min-w-[40vw] md:min-w-[15vw] lg:w-[15vw]  group-hover:flex items-center right-full mr-3 top-1/2 transform -translate-y-1/2 bg-[#EFEFEF] bg-opacity-100 z-20 text-black text-[12px] leading-5 p-3 rounded-lg w-fit">
                //         You Haven't reached the cut-off score for the{" "}
                //         {interviewData?.technicalInterview
                //           ?.isInterviewCompleted &&
                //         interviewData?.technicalInterview?.isResultPublished &&
                //         interviewData?.technicalInterview?.eligibleForNextRound
                //           ? "Next Interview"
                //           : "Next Interview"}
                //         <div className="w-0 h-0 border-[20px] absolute top-1/2 -translate-y-1/2 -right-2 border-y-[10px] border-transparent border-l-[#EFEFEF] border-r-0"></div>
                //       </div>
                //     }
                //   </div>
                // </p>
              )
            }
          </div>
        )}
      </>

      <div
        className="p-4 md:p-3 lg:p-12 "
        onClick={() => console.log(interviewData)}
      >
        <div className="justify-between mb-8 md:flex  md:mt-[7%] mt-[10%] lg:mt-[5%] ">
          <div className="w-full justify-between flex items-center">
            <div className="w-full md:w-3/4 flex flex-col md:flex-row justify-between items-center">
              <h1 className="text-3xl gil-bold">Interview Report</h1>
              {JSON.parse(localStorage.getItem("user"))?.role?.role ===
                "student" &&
                !interviewData?.isInterviewCompleted &&
                !interviewData?.isResultPublished &&
                interviewData && (
                  <span className=" w-full md:w-[40%] flex items-center justify-end">
                    <button
                      className="bg-yellow hover:bg-yellow  text-white py-2 px-4 rounded-lg transition-colors duration-300"
                      onClick={() => {
                        navigate(`/interview/?continue=${interviewData._id}`);
                      }}
                    >
                      {" "}
                      Continue Interview
                    </button>
                  </span>
                )}
              {JSON.parse(localStorage.getItem("user"))?.role?.role ===
                "company" &&
                fromInterview && (
                  <HireDropDown
                    interview={true}
                    handleShortlist={async () => {
                      setLoader(true);
                      const response = await InterviewStore.handleStatusChange(
                        interviewData._id,
                        "shortlisted",
                      );

                      if (response.success) {
                        setInterviewData(response.data);
                      }
                      setLoader(false);
                    }}
                    handleReject={async () => {
                      setLoader(true);
                      const response = await InterviewStore.handleStatusChange(
                        interviewData._id,
                        "rejected",
                      );
                      if (response.success) {
                        setInterviewData(response.data);
                      }
                      setLoader(false);
                    }}
                    main={
                      interviewData?.status === 1
                        ? "Shortlisted"
                        : interviewData?.status === 2
                          ? "Rejected"
                          : "Pending"
                    }
                    statusColor={
                      interviewData?.status === 1
                        ? "bg-blue-500"
                        : interviewData?.status === 2
                          ? "bg-red-500"
                          : "bg-yellow"
                    }
                    className="-ml-5"
                  />
                )}
            </div>
            <p className="text-[#747474] md:block lg:block hidden opacity-50 mb-2 mx-2 text-sm font-semibold">
              Id: {interviewData?._id}
            </p>
          </div>
          <p className="text-[#747474] block md:hidden lg:hidden my-2 opacity-50 mb-2 mx-2 text-sm font-semibold">
            Id: {interviewData?._id}
          </p>
          {/* {showPopup && (
          <div className="absolute w-screen top-0 h-screen z-50 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40 ">
            <div className="fixed top-20 inset-x-0 bg-bg3 z-50 flex flex-col justify-center rounded items-center md:w-[25%] lg:w-[25%] w-[90%] h-[50vh] m-auto shadow-lg  p-2">
              <div className="flex flex-col  items-center w-[100%] h-full py-5 ">
                <AiFillCloseCircle
                  className="text-primary absolute text-2xl cursor-pointer  top-2 right-2"
                  onClick={closePopup}
                />
                <div className="flex items-center w-[100%] justify-between text-gray-800 border mt-2 border-gray-800 bg-white max-w-sm font-mono text-sm py-3 px-4 rounded-md">
                  <textarea
                    rows={4}
                    defaultValue={`https://app.reaidy.io/report/${id}`}
                    className="w-full p-2"
                  />

                  <span
                    class="flex text-gray-800 cursor-pointer w-5 h-5 hover:text-gray-400 duration-200"
                    onClick={handleCopyClick}>
                    {" "}
                    <AiOutlineCopy className="text-xl active:text-primary" />
                  </span>
                </div>
                <p className="text-primary mt-5">
                  copy the above url and share
                </p>
              </div>
            </div>
          </div>
        )} */}
          <JobShare
            isPopupVisible={showPopup}
            handlePopUpVisible={handlePopUp}
            emailSubject={"Sharing My Interview Report"}
            emailBody={"You can access the report using the following link: "}
            link={{
              jobPostLink: `https://${getDomainForWhiteLabeling()}/report/${id}`,
              clientLink: `https://${getDomainForWhiteLabeling()}/report/${id}`,
            }}
          />
        </div>
        <div className="flex mx-3 mt-10 md:mt-0">
          {/* <button
            onClick={downloadReport}
            className="mx-3 flex flex-row items-center  bg-bg3 hover:bg-primary text-primary hover:text-bg3 gil-bold py-2 px-4 rounded focus:outline-none"
          >
            <MdDownload className="mr-2 " /> Report
          </button> */}
          {/* <button
            // onClick={getBlobFromMobx}
            onClick={downloadRecordedVideoFromStorage}
            className="mx-3 flex flex-row items-center   bg-primary text-white hover:border-2 hover:border-primary hover:bg-transparent hover:text-primary  gil-bold py-2 px-4 rounded focus:outline-none"
          >
            <MdDownload className="mr-2" /> Screen record
          </button> */}
        </div>

        {/* MOBILE VIEW  */}
        <div className="md:hidden lg:hidden block">
          {!isResultGenerated && <WarningCard onRegenerate={hitResultAPI} />}
        </div>

        {/* MOBILE VIEW  */}
        <div className="md:hidden lg:hidden block">
          {interviewData?.isInterviewCompleted &&
            isResultGenerated &&
            (interviewData?.result[0]?.score === 0 ||
              interviewData?.result[1]?.score === 0 ||
              interviewData?.result[2]?.score === 0) && (
              <ReportRegenerate onRegenerate={() => hitResultAPI(true)} />
            )}
        </div>

        {/* MOBILE VIEW */}
        <div className="lg:hidden md:hidden">{sharebutton()}</div>
        <div className="lg:hidden md:hidden">{downloadReportButton()}</div>
        <div className="lg:hidden md:hidden">
          <ScreenRecordVideo
            isRecordAvailable={isRecordAvailable}
            getVideoLinkFromStorage={getVideoLinkFromStorage()}
            downloadRecordedVideoFromStorage={downloadRecordedVideoFromStorage}
          />
        </div>

        {/* WEB VIEW */}
        <div className="flex md:flex-row lg:flex-row flex-col">
          <div className=" bg-white rounded-xl shadow-2xl shadow-slate-200 w-full md:w-3/4 lg:w-3/4">
            <div className="p-4 flex flex-col lg:flex-row md:flex-row md:w-[54vw] px-7 gap-[2vw] lg:w-fit items-center justify-around">
              {loading ? (
                // Shimmer placeholders while loading
                // <div className=" p-4 flex flex-col lg:flex-row md:flex-row justify-around w-full mb-4 h-[30vh]">
                <>
                  <div className="flex justify-center items-center w-[15vw] h-[15vw] rounded-full border border-[1rem] border-gray-200 relative bg-gray-100 shadow-sm">
                    <div className=" w-[3rem] h-[3rem]  rounded-md bg-gray-200"></div>
                  </div>
                  <div className="flex justify-center items-center w-[15vw] h-[15vw] rounded-full border border-[1rem] border-gray-200 relative bg-gray-100 shadow-sm">
                    <div className=" w-[3rem] h-[3rem]  rounded-md bg-gray-200"></div>
                  </div>
                  <div className="flex justify-center items-center w-[15vw] h-[15vw] rounded-full border border-[1rem] border-gray-200 relative bg-gray-100 shadow-sm">
                    <div className=" w-[3rem] h-[3rem]  rounded-md bg-gray-200"></div>
                  </div>
                </>
              ) : (
                // </div>
                // Actual content when loading is complete
                <>
                  <RadialBarChart
                    score={getTheResultByTopic("communication_score")}
                    label={"Communication"}
                  />
                  <RadialBarChart
                    score={getTheResultByTopic("technical_score")}
                    label={"Technical"}
                  />
                  <RadialBarChart
                    score={getOverallScore()}
                    label={"Overall Performance"}
                  />
                </>
              )}
            </div>

            {loading ? (
              <div className="w-full bg-gray-50 p-4 rounded-xl shadow-lg">
                {/* Title Skeleton */}
                <div className="h-6 w-1/3 bg-gray-200 rounded mb-4 shadow-sm"></div>

                {/* Questions and Answers Skeleton */}
                <div className="mb-4">
                  <div className="h-4 bg-gray-200 rounded w-3/4 mb-2 shadow-sm"></div>
                  <div className="h-4 bg-gray-200 rounded w-full mb-2 shadow-sm"></div>
                  <div className="h-4 bg-gray-200 rounded w-1/2 shadow-sm"></div>
                </div>
                <div className="mb-4">
                  <div className="h-4 bg-gray-200 rounded w-3/4 mb-2 shadow-sm"></div>
                  <div className="h-4 bg-gray-200 rounded w-full mb-2 shadow-sm"></div>
                  <div className="h-4 bg-gray-200 rounded w-1/2 shadow-sm"></div>
                </div>

                {/* Behavior Section Skeleton */}
                <div className="mt-6">
                  <div className="h-4 bg-gray-200 rounded w-1/4 mb-2 shadow-sm"></div>
                  <div className="h-4 bg-gray-200 rounded w-3/4 mb-2 shadow-sm"></div>
                  <div className="h-4 bg-gray-200 rounded w-2/4 mb-2 shadow-sm"></div>
                </div>

                {/* Suggestions Section Skeleton */}
                <div className="mt-6">
                  <div className="h-6 bg-gray-200 rounded w-1/4 mb-4 shadow-sm"></div>
                  <ul>
                    <li className="h-4 bg-gray-200 rounded w-3/4 mb-2 shadow-sm"></li>
                    <li className="h-4 bg-gray-200 rounded w-3/4 mb-2 shadow-sm"></li>
                    <li className="h-4 bg-gray-200 rounded w-3/4 shadow-sm"></li>
                  </ul>
                </div>

                {/* Summary Section Skeleton */}
                <div className="mt-6">
                  <div className="h-6 bg-gray-200 rounded w-1/4 mb-4 shadow-sm"></div>
                  <div className="h-4 bg-gray-200 rounded w-full shadow-sm"></div>
                </div>
              </div>
            ) : (
              <div className=" p-4 md:px-10 ">
                <span className="flex justify-between">
                  <h2 className="text-xl gil-bold mb-4">Questions & Answers</h2>
                  {interviewData?.interviewType !== "real" ? (
                    <button
                      className="text-primary text-md hover:underline"
                      onClick={sendReq}
                    >
                      Show Actual Answers
                    </button>
                  ) : (
                    <></>
                  )}
                </span>
                {questions.map((q, key) => {
                  return (
                    <div key={key} className="mb-4">
                      <h3 className="gil-bold">Question: {q.question}</h3>
                      <p>Answer: {q.answer}</p>
                      {/* <p className="text-gray-500">Score: {q.score}</p> */}
                      {view ? (
                        <p className="">
                          <span className="">Actual answers</span>:{" "}
                          {q.actualAnswer}
                        </p>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            )}

            {/* for Behavioural assessment and Resume match with JD  */}
            <div className="">
              <Behaviour
                professionalScore={getTheResultByTopic("professionalism_score")}
                positivenessScore={getTheResultByTopic("positiveness_score")}
                communicationScore={getTheResultByTopic("communication_score")}
                sociabilityScore={getTheResultByTopic("sociability_score")}
              />
            </div>
            {getTheResultByTopic("interviewSuggestion") !== 0 && (
              <div className="p-4 md:px-10 mb-8">
                <h2 className="text-xl gil-bold mb-4">Suggestions</h2>
                <ul>
                  {getTheResultByTopic("interviewSuggestion")
                    .split("\n\n")
                    .map((point, index) => (
                      <li key={index}>{point}</li>
                    ))}
                </ul>
              </div>
            )}

            <div className="  p-4 md:px-10 mb-8">
              <h2 className="text-xl gil-bold mb-4">Summary</h2>
              <p>{getTheResultByTopic("summerySuggestion")}</p>
            </div>
          </div>

          {/* MOBILE VIEW */}

          <div className="block md:hidden lg:hidden w-full">
            {interviewBasicData()}
            {/* {studentResume()} */}
            {shallShowCandidateDetails() && (
              <UserDetailsCard
                profilePic={interviewData?.interviewee?.pic}
                name={interviewData?.interviewee?.name}
                email={interviewData?.interviewee?.mail}
                mobile={interviewData?.interviewee?.mobile}
                role={interviewData?.interviewee?.role?.role}
                designation={interviewData?.interviewee?.designation}
                collegeName={interviewData?.interviewee?.college}
                skills={interviewData?.interviewee?.skills ?? []}
                technicalScore={interviewData?.interviewee?.technicalSkills}
                communicationScore={
                  interviewData?.interviewee?.communicationSkills
                }
                joinedAt={interviewData?.interviewee?.createdAt}
                checkLogin={checkUserLoggedInOrNot}
                userId={interviewData?.interviewee?._id}
                city={interviewData?.interviewee?.city}
              />
            )}
            {/* {shallShowCandidateDetails() && (
              <div className="my-5">
                <h2 className="text-xl gil-bold mb-4">Previous Interviews</h2>
                {PreviousInterviewList()}
              </div>
            )} */}
            {/* {ScreenRecordVideo()} */}
          </div>
          <div className="w-1/4 pl-4 hidden md:block lg:block">
            {showTimer && (
              <div className="bg-white shadow-lg rounded-lg p-4 mb-8">
                <h2 className="text-xl gil-bold mb-4">Please wait</h2>
                <CountdownTimer />

                <p className="mt-2">
                  Please wait untill time ends.{" "}
                  <span className="text-yellow">
                    Then Refresh this page
                  </span>{" "}
                </p>
              </div>
            )}
            {!isResultGenerated && <WarningCard onRegenerate={hitResultAPI} />}
            {interviewData?.isInterviewCompleted &&
              isResultGenerated &&
              (interviewData?.result[0]?.score === 0 ||
                interviewData?.result[1]?.score === 0 ||
                interviewData?.result[2]?.score === 0) && (
                <ReportRegenerate onRegenerate={() => hitResultAPI(true)} />
              )}

            <div className="md:block hidden lg:block">{profilebutton()}</div>

            {/* <div className="md:block hidden lg:block">{sharebutton()}</div> */}

            <div className="md:block hidden lg:block">
              <ScreenRecordVideo
                isRecordAvailable={isRecordAvailable}
                getVideoLinkFromStorage={getVideoLinkFromStorage()}
                downloadRecordedVideoFromStorage={
                  downloadRecordedVideoFromStorage
                }
              />
            </div>

            <div className="md:block hidden lg:block">
              {downloadReportButton()}
            </div>
            {/* <div className="md:block hidden lg:block"> {skillsAssesment()}</div> */}

            <div className="md:block hidden lg:block">
              {" "}
              {shallShowCandidateDetails() && (
                <UserDetailsCard
                  profilePic={interviewData?.interviewee?.pic}
                  name={interviewData?.interviewee?.name}
                  email={interviewData?.interviewee?.mail}
                  mobile={interviewData?.interviewee?.mobile}
                  role={interviewData?.interviewee?.role?.role}
                  designation={interviewData?.interviewee?.designation}
                  collegeName={interviewData?.interviewee?.college}
                  skills={interviewData?.interviewee?.skills ?? []}
                  technicalScore={interviewData?.interviewee?.technicalSkills}
                  communicationScore={
                    interviewData?.interviewee?.communicationSkills
                  }
                  joinedAt={interviewData?.interviewee?.createdAt}
                  checkLogin={checkUserLoggedInOrNot}
                  userId={interviewData?.interviewee?._id}
                  city={interviewData?.interviewee?.city}
                />
              )}
            </div>

            {/* {shallShowCandidateDetails() && studentResume()} */}

            <div className="md:block hidden lg:block">
              {" "}
              {interviewBasicData()}
              {/* {shallShowCandidateDetails() && (
                <div className="my-5">
                  <h2 className="text-xl gil-bold mb-4">Previous Interviews</h2>
                  {PreviousInterviewList()}
                </div>
              )} */}
            </div>
            {/* <div className="md:block hidden lg:block">
            {TotalInterviews()}
            <div className="w-full">
              <PreviousInterview />
            </div>
          </div> */}
          </div>
        </div>

        <div className="bg-white shadow-lg rounded-lg p-4 mt-8">
          <img
            src={`${getLogoBySubdomain(true)}`}
            className="h-7 my-3"
            alt=""
          />
          {/* Note section */}
          <div className="flex items-center justify-between bg-gray-100 p-2 rounded-lg">
            <p className="text-sm text-gray-600">
              Note: The report was generated by the Artificial Intelligence
              system it was approximate and may not be 100% accurate.
            </p>
          </div>
        </div>
      </div>
    </div>
  ));
  function studentResume() {
    return (
      <div className="bg-white shadow-lg p-5 rounded-lg sm:block">
        <h1 className="text-lg font-bold">Candidate Resume</h1>
        <p
          className={`${
            interviewData?.resumeLink ? "bg-primary" : "bg-gray-400"
          } h-10 text-center text-white flex justify-between items-center rounded-lg py-2 px-3 mt-2`}
        >
          {" "}
          <div
            className="flex justify-center items-center gap-2 cursor-pointer"
            onClick={() => {
              openResumeByLink(interviewData?.resumeLink);
            }}
          >
            {" "}
            <IoIosDocument className="text-2xl text-white" />{" "}
            <p className="text-lg ">Resume</p>{" "}
          </div>{" "}
          {pdf && <PdfViewer pdfUrl={resumeLink} onClose={closePopup} />}
          <MdOutlineFileDownload
            onClick={() => {
              downloadPDF(interviewData?.resumeLink);
            }}
            className="text-2xl hover:text-primary cursor-pointer "
          />{" "}
        </p>
      </div>
    );
  }

  function CandidateResume() {
    return (
      <div className="bg-white shadow-lg p-5 rounded-lg sm:block">
        <h1 className="text-lg font-bold">Candidate Resume</h1>
        <p
          className={`${
            interviewData?.resumeLink ? "bg-primary" : "bg-gray-400"
          } h-10 text-center text-white flex justify-between items-center rounded-lg py-2 px-3 mt-2`}
        >
          {" "}
          <div
            className="flex justify-center items-center gap-2 cursor-pointer"
            onClick={() => {
              openResumeByLink(interviewData?.resumeLink);
            }}
          >
            {" "}
            <IoIosDocument className="text-2xl text-white" />{" "}
            <p className="text-lg ">Resume</p>{" "}
          </div>{" "}
          {pdf && <PdfViewer pdfUrl={resumeLink} onClose={closePopup} />}
          <MdOutlineFileDownload
            onClick={() => {
              openResumeByLink(interviewData?.resumeLink);
            }}
            className="text-2xl hover:text-primary cursor-pointer "
          />{" "}
        </p>
        <button className="text-primary">download</button>
      </div>
    );
  }

  function downloadReportButton() {
    return (
      <div className="bg-white shadow-lg rounded-lg p-4 mb-8">
        <h2 className="text-xl gil-bold mb-4"> Candidate Report </h2>
        {isResultGenerated ? (
          <button
            className="flex justify-start items-start bg-primary text-white w-full py-2 px-3 font-bold rounded-md"
            onClick={navigateToCertificate}
          >
            <MdOutlineFileDownload className="text-white mr-3 text-2xl" />{" "}
            Download
          </button>
        ) : (
          <button
            disabled
            className="flex justify-start items-start bg-gray-700 text-white w-full py-2 px-3 font-bold rounded-md"
            onClick={navigateToCertificate}
          >
            <MdDownload className="text-white mr-3" /> Download
          </button>
        )}
      </div>
    );
  }

  function interviewBasicData() {
    const getTheDurationBy2Time = (startTime, endTime) => {
      const start = new Date(startTime);
      const end = new Date(endTime);
      // return mm:ss format
      const duration = Math.abs(end - start);
      const minutes = Math.floor(duration / 1000 / 60);
      const seconds = Math.floor((duration / 1000) % 60);
      return ` ${minutes}m:${seconds}s`;
    };

    const getRecordedTime = () => {
      try {
        if (InterviewStore.recordingTime) {
          return InterviewStore.recordingTime;
        } else if (
          interviewData?.interviewCompletedAt &&
          interviewData?.createdAt
        ) {
          return getTheDurationBy2Time(
            interviewData?.createdAt,
            interviewData?.interviewCompletedAt,
          );
        } else return "-";
      } catch (error) {
        return "-";
      }
    };

    return (
      <div className="bg-white shadow-lg rounded-lg p-4 my-8">
        <h2 className="text-xl gil-bold mb-4">Interview Details</h2>
        <div className="flex items-center mb-4">
          <FaUser className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">Interviewee:</span>{" "}
            {interviewData?.interviewee?.name}
          </p>
        </div>
        <div className="flex items-center mb-4">
          <FaUserTie className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">Interview Type:</span>{" "}
            {getInterviewTitle(interviewData?.interviewId)}
          </p>
        </div>
        <div className="flex items-center mb-4">
          <FaClock className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">Duration:</span>
            {getRecordedTime()}
          </p>
        </div>
        <div className="flex items-center mb-4">
          <FaUserTie className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">Interviewer:</span>{" "}
            {interviewData?.interviewerName ?? "Lucy"}
          </p>
        </div>

        <div className="flex items-center mb-4">
          <FaTags className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">Topic:</span>{" "}
            {interviewData?.technology === ""
              ? interviewData?.role
              : interviewData?.technology}
          </p>
        </div>
        <div className="flex items-center mb-4">
          <FaHashtag className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">ID:</span> {interviewData?._id ?? "-"}
          </p>
        </div>
        <div className="flex items-center mb-4">
          <FaMicrophone className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">Microphone:</span>{" "}
            {interviewDetails.interviewPermissionMic
              ? "Allowed"
              : "Not Allowed"}
          </p>
        </div>
        <div className="flex items-center mb-4">
          <FaVideo className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">Video:</span>{" "}
            {interviewDetails.interviewPermissionVideo
              ? "Allowed"
              : "Not Allowed"}
          </p>
        </div>
        <div className="flex items-center">
          <FaChartBar className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">Level:</span>{" "}
            {interviewData?.levelOfInterview}
          </p>
        </div>
      </div>
    );
  }

  function sharebutton() {
    return (
      <div className="bg-white shadow-lg rounded-lg p-4 mb-8">
        <h2 className="text-xl gil-bold mb-4"> Share this Report </h2>
        <button
          className="flex  justify-start items-start  bg-primary text-white w-[100%] py-2 px-3 font-bold rounded-md "
          onClick={openPopup}
        >
          <AiOutlineShareAlt className="text-2xl mr-3" /> Share
        </button>
      </div>
    );
  }
  function profilebutton() {
    const showProfile = () => {
      const verified = JSON.parse(
        localStorage.getItem("user"),
      )?.isAccountVerified;
      console.log("verify", verified);
      return verified;
    };

    return (
      <>
        {showProfile() ? (
          <div className="bg-white shadow-lg rounded-lg p-4 mb-8">
            <h2 className="text-xl gil-bold mb-4"> Candidate Profile </h2>
            {/* <div className="flex justify-between items-center gap-2 "> */}
            <button
              className="flex  justify-start items-start  bg-green-600 text-white w-[100%] py-2 px-3 font-bold rounded-md "
              onClick={() => {
                navigate(
                  `/company/settings/${interviewData?.interviewee?._id}`,
                );
                // window.location.href = `https://app.reaidy.io/company/settings/${interviewData?.interviewee?._id}`
              }}
            >
              <RiProfileLine className="text-2xl mr-3" /> Show the Profile
            </button>
            <button
              className="flex  justify-start items-start  bg-primary text-white w-[100%] py-2 px-3 font-bold rounded-md mt-2"
              onClick={openPopup}
            >
              <AiOutlineShareAlt className="text-2xl mr-3" /> Share the Report
            </button>
            {/* </div> */}
          </div>
        ) : (
          <div></div>
        )}
      </>
    );
  }

  function PreviousInterviewList() {
    const { RecuiterStore } = useStores();
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const clientId = searchParams.get("clientId");

    useEffect(() => {
      // isActualAnswersAvaialble();

      RecuiterStore.fetchApplicantInterviews(id, clientId);
    }, []);

    const timeStampToDate = (timestamp) => {
      const date = new Date(timestamp);
      const dayOfWeek = date.toLocaleDateString("en-US", { weekday: "long" });
      const fullDate = date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      return `${fullDate}`;
    };
    const isReportAvailable = () => {
      return (
        <div className="flex ">
          <p className="px-1 text-yellow">
            <FiAlertTriangle />
          </p>
          <p className="text-sm text-yellow ">
            {" "}
            you haven't Completed the interview
          </p>
        </div>
      );
    };

    return (
      <Observer>
        {() => (
          <div className=" w-[100%] mx-auto items-center flex flex-col justify-center ">
            {RecuiterStore?.applicantInterviews?.length === 0 ? (
              <div className="w-[95%]  past-interviews   ">
                <div className="  rounded-[15px] w-full mb-0 md:mb-[100%] lg:mb-[100%] flex flex-col items-center justify-center ">
                  {/* <h1 className="text-[25px] text-[#010E78]  ">
            No Previous Interviews
          </h1> */}
                  {/* <img
                    src={nointerviewsimage}
                    className="w-[250px] h-[250px] rounded-full"
                    alt=""
                  /> */}
                  {/* <p className="text-base text-primary  ">
                    No Previous Interviews
                  </p> */}
                </div>
              </div>
            ) : (
              <div
                className={`w-[100%] md:w-[100%] lg:w-[90%] m-auto ${
                  RecuiterStore.applicantInterviews.length > 3
                    ? "h-[103vh]"
                    : "h-auto"
                } md:ml-3 bg-slate-100   rounded-lg overflow-y-scroll no-scrollbar`}
              >
                <div className="w-[96%] md:w-[95%] lg:w-[90%]  md:mx-auto lg:mx-auto  past-interviews mx-auto  ">
                  {RecuiterStore?.applicantInterviews
                    .slice()
                    .reverse()
                    .map((interview, index) => (
                      <div className="w-[100%]  pb-[10px] h-auto bg-white md:-ml-2 lg:-ml-2 -ml-0 rounded-[10px] mt-[17px] flex  justify-center gap-2">
                        <div className=" flex flex-row pt-5 px-3 ">
                          {RecuiterStore?.applicantInterviews?.length - index <
                          10 ? (
                            <h1 className="text-[20px]  bg-gray-200 h-10 text-text_color3 border border-1  rounded-md px-3 mb-auto py-1">
                              0
                              {RecuiterStore?.applicantInterviews?.length -
                                index}
                            </h1>
                          ) : (
                            <h1 className="text-[20px] my-1 bg-gray-200 h-10 text-text_color3 border border-1  rounded-md px-3 mb-auto py-1">
                              {RecuiterStore?.applicantInterviews?.length -
                                index}
                            </h1>
                          )}
                        </div>
                        <div className="flex flex-col items-start pt-4 ">
                          <div className="flex flex-col text-start  ">
                            <p className=" text-[17.52px] my-auto  text-text_color3">
                              Topic: {interview?.technology}
                            </p>
                            <div className="flex flex-row ">
                              <p className=" text-[17.52px] my-auto text-primary ">
                                <span className=" text-text_color3 ">
                                  Level:
                                </span>{" "}
                                {interview?.levelOfInterview}
                              </p>
                              <p className=" mx-auto my-auto text-xs text-text_color3 opacity-70 px-3 ">
                                {timeStampToDate(interview?.createdAt)}
                              </p>
                            </div>
                            <h1 className="text-[17px] my-auto text-text_color3 rounded-md py-1">
                              Questions: {interview?.noOfQuestions}
                            </h1>
                          </div>

                          {interview?.isInterviewCompleted &&
                          interview?.isResultPublished ? (
                            <div className="flex text-xs  text-black  ">
                              <div className=" pr-2">
                                <p className=" gil-med text-lg ">
                                  {typeof interview?.result[2]?.score ===
                                    "number" &&
                                  !isNaN(interview?.result[2]?.score)
                                    ? interview?.result[2].score.toFixed(1)
                                    : 0}
                                  %
                                </p>
                                <p className="text-[10px] opacity-70">
                                  Communication
                                </p>
                              </div>
                              <div className=" px-2">
                                <p className="text-lg gil-med">
                                  {typeof interview?.result[1]?.score ===
                                    "number" &&
                                  !isNaN(interview?.result[1]?.score)
                                    ? interview?.result[1].score.toFixed(1)
                                    : 0}
                                  %
                                </p>
                                <p className="text-[10px] opacity-70">
                                  Technical Skills{" "}
                                </p>
                              </div>
                              <div className=" px-2">
                                <p className="text-lg gil-med ">
                                  {typeof interview?.result[0]?.score ===
                                    "number" &&
                                  !isNaN(interview?.result[0]?.score)
                                    ? interview?.result[0].score.toFixed(1)
                                    : 0}
                                  %
                                </p>
                                <p className="text-[10px] opacity-70">
                                  Over all score
                                </p>
                              </div>
                            </div>
                          ) : (
                            <div className="">{isReportAvailable()}</div>
                          )}

                          <Link
                            to={
                              //   from === "mobile"
                              //     ? `/report/${interview?._id}`
                              `/company/report/${interview?._id}`
                            }
                            className=" text-right my-auto flex items-center text-sm justify-start w-full "
                          >
                            {" "}
                            <span className="text-primary">View more</span>{" "}
                            <MdArrowCircleRight className="text-primary mx-1" />
                          </Link>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
        )}
      </Observer>
    );
  }

  function skillsAssesment() {
    return (
      <div className="bg-white shadow-lg rounded-lg p-4 mb-8">
        <h2 className="text-xl gil-bold mb-4">Skills Assessment</h2>
        <div className="mb-4">
          <h3 className="gil-bold">Communication Skills</h3>
          <div className="relative w-full bg-gray-200 rounded-full overflow-hidden">
            <div
              className="h-2 bg-primary"
              style={{
                width: `${
                  (getTheResultByTopic("communication_score") / 10) * 10
                }%`,
              }}
            ></div>
          </div>
          <p>{getTheResultByTopic("communication_score") / 10}/10</p>
        </div>
        <div>
          <h3 className="gil-bold">Technical Skills</h3>
          <div className="relative w-full bg-gray-200 rounded-full overflow-hidden">
            <div
              className="h-2 bg-primary"
              style={{
                width: `${(getTheResultByTopic("technical_score") / 10) * 10}%`,
              }}
            ></div>
          </div>
          <p>{getTheResultByTopic("technical_score") / 10}/10</p>
        </div>
      </div>
    );
  }
};
// export const PdfViewer = ({ pdfUrl, onClose }) => {
//   const [numPages, setNumPages] = useState(null);
//   const [pageNumber, setPageNumber] = useState(1);

//   const onDocumentLoadSuccess = ({ numPages }) => {
//     setNumPages(numPages);
//   };

//   return (
//     <div className="w-full h-full fixed top-0 left-0 z-50 bg-black bg-opacity-50 flex justify-center items-center">
//       <div className="bg-white w-11/12 h-5/6 overflow-y-scroll">
//         <div className="flex justify-end items-center">
//           <button onClick={onClose} className="text-2xl text-red-500 hover:text-red-700 mr-2">
//             X
//           </button>
//         </div>
//         <Document
//           file={pdfUrl}
//           onLoadSuccess={onDocumentLoadSuccess}
//         >
//           <Page pageNumber={pageNumber} />
//         </Document>
//         <p>
//           Page {pageNumber} of {numPages}
//         </p>
//       </div>
//     </div>
//   );
// };

export const WarningCard = ({ onRegenerate }) => {
  return useObserver(() => (
    <div className="max-w-sm mx-auto bg-white border border-yellow rounded-lg shadow-lg p-6 mb-8">
      <div className="flex items-center mb-4">
        <FiAlertTriangle className="text-yellow text-4xl mr-2" />
        <h2 className="text-xl font-bold">Result not generated</h2>
      </div>
      <p className="text-gray-600 mb-4">
        Oops! There was an error generating your result. Please try again.
      </p>
      <button
        className="bg-yellow hover:bg-yellow text-white py-2 px-4 rounded-lg transition-colors duration-300"
        onClick={() => {
          onRegenerate && onRegenerate();
        }}
      >
        Regenerate Result
      </button>
    </div>
  ));
};

export const ReportRegenerate = ({ onRegenerate }) => {
  return useObserver(() => (
    <div className="max-w-sm mx-auto bg-white border border-yellow rounded-lg shadow-lg p-6 mb-8">
      <div className="flex items-center mb-4">
        <FiAlertTriangle className="text-yellow text-4xl mr-2" />
        <h2 className="text-xl font-bold">Regenerate Report</h2>
      </div>
      <p className="text-gray-600 mb-4">
        If you feel that the generated report is not accurate, click the below
        button to regenerate the report.
      </p>
      <button
        className="bg-yellow hover:bg-yellow text-white py-2 px-4 rounded-lg transition-colors duration-300"
        onClick={() => {
          onRegenerate && onRegenerate();
        }}
      >
        Regenerate Report
      </button>
    </div>
  ));
};

const FeedbackWarning = ({ onRegenerate }) => {
  return (
    <div className="max-w-sm mx-auto bg-white border border-yellow rounded-lg shadow-lg p-6 mb-8 sticky">
      <div className="flex items-center mb-4">
        <FiAlertTriangle className="text-yellow text-4xl mr-2" />
        <h2 className="text-xl font-bold">Your Feedback</h2>
      </div>
      <p className="text-gray-600 mb-4">
        Your feedback is important to us. Please take a moment to share your
        experience.
      </p>
      <button
        className="bg-yellow hover:bg-yellow text-white py-2 px-4 rounded-lg transition-colors duration-300"
        onClick={() => {
          onRegenerate && onRegenerate();
        }}
      >
        Feedback
      </button>
    </div>
  );
};

const RadialBarChart = ({ label, score }) => {
  const circumference = 2 * Math.PI * 45;
  const progress = (score / 100) * circumference;

  return useObserver(() => (
    <div className="relative w-52 h-52 m-2">
      <svg
        className="absolute top-0 left-0 w-full h-full"
        viewBox="0 0 100 100"
      >
        <circle
          className="text-gray-300 stroke-current"
          cx="50"
          cy="50"
          r="45"
          fill="none"
          strokeWidth="10"
        />
        <circle
          className={classNames(
            "text-primary stroke-current transition-all duration-500",
            {
              "stroke-dashoffset-0": score > 0,
              "stroke-dashoffset-full": score === 0,
            },
          )}
          cx="50"
          cy="50"
          r="45"
          fill="none"
          strokeWidth="10"
          strokeDasharray={circumference}
          strokeDashoffset={circumference - progress}
          strokeLinecap="round"
          transform="rotate(-90, 50, 50)"
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-primary font-bold text-4xl">
        {score}

        <br />
        <div className="flex items-center justify-center text-gray-500 text-xs md:text-[0.65rem]">
          {label}
        </div>
      </div>
    </div>
  ));
};

export default ReportScreen;

export function ScreenRecordVideo({
  isRecordAvailable,
  getVideoLinkFromStorage,
  downloadRecordedVideoFromStorage,
}) {
  const [first, setfirst] = useState(false);

  useEffect(() => {
    setfirst(!first);
    // alert(getVideoLinkFromStorage);
  }, [getVideoLinkFromStorage]);

  // alert(getVideoLinkFromStorage());
  console.log(
    "isRecordAvailable",
    isRecordAvailable,
    getVideoLinkFromStorage,
    ",",
    downloadRecordedVideoFromStorage,
  );
  return (
    <Observer>
      {() => (
        <div className="bg-white shadow-lg rounded-lg p-4 mb-8">
          <h2 className="text-xl gil-bold mb-4"> Record session </h2>
          {isRecordAvailable === null ? (
            "Loading..."
          ) : isRecordAvailable ? (
            <>
              <video className="w-full" controls>
                <source src={getVideoLinkFromStorage} type="video/mp4" />
              </video>
              <button
                onClick={downloadRecordedVideoFromStorage}
                className="flex flex-row items-center text-sm mt-1 text-primary border-2 border-white hover:border-2 hover:border-primary hover:bg-transparent hover:text-primary  gil-bold py-2 px-4 rounded focus:outline-none"
              >
                <MdDownload className="mr-2" /> Download
              </button>
            </>
          ) : (
            <h2 className=" text-base font-bold">Recording not available</h2>
          )}
        </div>
      )}
    </Observer>
  );
}
